import {
  PersonalPhoto,
  WatermarkOption
} from '../../../slices/mySpace/personalSpaceSlice'

// ========== 开关：接口就绪后改为 false ==========
// prod 构建始终关闭：webpack DefinePlugin 会把 process.env.NODE_ENV 替换为
// 'production'，配合 Terser DCE，下方所有 if (ENABLE_MOCK) 分支会被裁掉。
export const ENABLE_MOCK: boolean =
  process.env.NODE_ENV !== 'production' && false

// 真实照片资源（循环复用）
const REAL_PHOTOS = [
  {
    small: '/mock-photos/photo1.jpg',
    large: '/mock-photos/photo1.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo2.jpg',
    large: '/mock-photos/photo2.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo3.jpg',
    large: '/mock-photos/photo3.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo4.jpg',
    large: '/mock-photos/photo4.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo5.jpg',
    large: '/mock-photos/photo5.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo6.jpg',
    large: '/mock-photos/photo6.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo7.jpg',
    large: '/mock-photos/photo7.jpg',
    type: 0 as const
  },
  {
    small: '/mock-photos/photo1.jpg',
    large: '/mock-photos/video1.mp4',
    type: 1 as const
  },
  {
    small: '/mock-photos/photo2.jpg',
    large: '/mock-photos/video2.mp4',
    type: 1 as const
  }
]

function mockPhoto(index: number): PersonalPhoto {
  const day = 30 - Math.floor(index / 6)
  const hour = 8 + (index % 12)
  const minute = (index * 7) % 60
  const addrs = [
    '成都市武侯区·今日水印相机',
    '天府软件园E区',
    '高新区天府大道北段',
    '成都市锦江区·春熙路',
    '武侯区桂溪街道',
    '高新区神仙树路',
    '成都市青羊区·宽窄巷子',
    '天府新区·兴隆街道',
    '成都市龙泉驿区',
    '双流区·西航港'
  ]
  const watermarks = ['外勤打卡', '巡检记录', '施工日志', '安全检查']
  const asset = REAL_PHOTOS[index % REAL_PHOTOS.length]

  return {
    id: `mock-photo-${index}`,
    seq: index + 1,
    smallURL: asset.small,
    largeURL: asset.large,
    videoURL: asset.type === 1 ? asset.large : undefined,
    mediaType: asset.type,
    time: new Date(2026, 2, day > 0 ? day : 1, hour, minute, 0).getTime(),
    addr: addrs[index % addrs.length],
    watermarkName: watermarks[index % watermarks.length],
    watermarkID: `wm-${index % watermarks.length}`,
    photoNumber: String(index + 1).padStart(4, '0')
  }
}

const ALL_PHOTOS: PersonalPhoto[] = Array.from({ length: 60 }, (_, i) =>
  mockPhoto(i)
)

const ALL_WATERMARKS: WatermarkOption[] = [
  { id: 'wm-0', name: '外勤打卡' },
  { id: 'wm-1', name: '巡检记录' },
  { id: 'wm-2', name: '施工日志' },
  { id: 'wm-3', name: '安全检查' }
]

function delay(ms = 300) {
  return new Promise((r) => setTimeout(r, ms))
}

export async function mockFetchVipStatus() {
  await delay(200)
  return { isVip: true } // 改 false 可测试非会员拦截弹窗
}

export async function mockFetchWatermarks() {
  await delay(200)
  return { list: ALL_WATERMARKS }
}

export async function mockFetchPhotos(params: {
  page: number
  pageSize: number
  keyword?: string
  startTime?: number
  endTime?: number
  watermarkIds?: string
}) {
  await delay(500)
  let filtered = ALL_PHOTOS

  if (params.keyword) {
    const kw = params.keyword.toLowerCase()
    filtered = filtered.filter(
      (p) => (p.addr || '').includes(kw) || (p.watermarkName || '').includes(kw)
    )
  }
  if (params.startTime) {
    filtered = filtered.filter((p) => p.time >= params.startTime!)
  }
  if (params.endTime) {
    filtered = filtered.filter((p) => p.time <= params.endTime!)
  }
  if (params.watermarkIds) {
    const ids = params.watermarkIds.split(',')
    filtered = filtered.filter((p) => ids.includes(p.watermarkID || ''))
  }

  const start = (params.page - 1) * params.pageSize
  return {
    list: filtered.slice(start, start + params.pageSize),
    total: filtered.length
  }
}

export async function mockDeletePhotos(_ids: string[]) {
  await delay(300)
  return { success: true }
}

export async function mockDownloadPhotos() {
  await delay(500)
  return { downloadUrl: '' }
}
